export class ApiEndpoints {
  static STOCK_WEBSOCKET_URL = 'ws://stocks.mnet.website';
}



// WEBPACK FOOTER //
// /home/travis/build/nishant95/stocks-app/src/app/shared/constant/api-endpoints.constant.ts